import { render } from "./SquareCTA.vue?vue&type=template&id=76193fbd"
import script from "./SquareCTA.vue?vue&type=script&lang=js"
export * from "./SquareCTA.vue?vue&type=script&lang=js"

import "./SquareCTA.vue?vue&type=style&index=0&id=76193fbd&lang=postcss"

import exportComponent from "/var/vhosts/unrisd-frontend/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__